import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import StoreProvider from "store/StoreProvider";

// Soft UI Dashboard React Context Provider
import { SoftUIControllerProvider } from "context";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import 'dayjs/locale/en-gb';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
  <ToastContainer position="top-right" autoClose={3000} />
  <BrowserRouter>
    <SoftUIControllerProvider>
      <StoreProvider>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
          <App />
        </LocalizationProvider>
      </StoreProvider>
    </SoftUIControllerProvider>
  </BrowserRouter>
  </>
);
